//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  required,
  minLength,
  maxLength
} from 'vuelidate/lib/validators'

export default {
  name: "PopUpAuthorizationRegistration",

  data: function () {
    return {
      form: {
        phone: "",
        code: ""
      },

      stage: 0,

      isRegistration: false
    }
  },

  computed: {
    buttonSubmitLabel: function () {
      if (this.stage === 0) {
        return "Запросить код"
      }
      if (this.stage === 1) {
        return "Войти"
      }
      if (this.stage === 2) {
        return "Зарегестрироваться"
      }
    },

    errorPhone: function () {
      const error = this.$v?.form?.phone;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Неправильный формат ввода"
      }

      return null
    },
    errorCode: function () {
      const error = this.$v?.form?.code;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Код должен состоять из 4х символов"
      }
      if (!error.maxLength) {
        return "Код должен состоять из 4х символов"
      }

      return null
    },

    isRecaptcha: function () {
      return Boolean(Number.parseFloat(this.$store?.state?.appState?.config?.useReCaptchaForAuth || 0))
    }
  },

  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  validations: function () {
    let form = {
      phone: {
        required,
        notCorrect: minLength(18)
      }
    };
    if (this.stage === 1) {
      form.code = {
        required,
        minLength: minLength(4),
        maxLength: maxLength(4),
      }
    }

    return {
      form
    }
  },

  methods: {

    // Логика прохода цепочек авторизации / регистрации
    submitForm: async function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      this.$store.commit("local-settings/setShowDialogLoading", true);
      if (this.stage === 1 && !this.isRegistration) {
        await this._usersLogin();
      }
      if (this.stage === 1 && this.isRegistration) {
        await this._usersConfirmPhone();
      }
      if (this.stage === 0) {
        await this._usersRequest();
      }
      this.$store.commit("local-settings/setShowDialogLoading", false);
    },
    _usersRequest: async function () {
      const isUserFound = await this.$api.agent.transport.post('/users/check-exist', {phone: parseInt(this.form.phone.replace(/[^\d]/g, ''))})
        .then((res) => res.data)
        .catch((err) => false);
      if (!isUserFound) {
        await this._usersRegistration();
        return
      }


      const body = {
        username: parseInt(this.form.phone.replace(/[^\d]/g, ''))
      };
      if (this.isRecaptcha) {
        body['g-recaptcha-response'] = await this._getRecaptcha();
      }

      const response = await this.$api.agent.transport.post("/users/request", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: err.response}
      });
      if (response.error?.status === 500 || !response) {
        this.$toast.error("Ошибка сервера, повторите попытку позднее.");
        return
      }
      if (response.error?.data?.[0]?.message) {
        this.$toast.error(response.error?.data.map((t) => t.message).join("; "));
        return
      }
      if (response.error) {
        this.$toast.error(response.error?.data?.message);
        return
      }

      this.$toast.success("Звонок отправлен");
      this.stage = 1;

      return
    },
    _usersRegistration: async function () {
      const body = {
        phone: parseInt(this.form.phone.replace(/[^\d]/g, ''))
      };
      if (this.isRecaptcha) {
        body['g-recaptcha-response'] = await this._getRecaptcha();
      }
      const response = await this.$api.agent.transport.post("/users/signup", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: err.response}
      });
      if (response.error?.status === 500 || !response) {
        this.$toast.error("Ошибка сервера, повторите попытку позднее.");
        return
      }
      if (response.error?.data?.[0]?.message) {
        this.$toast.error(response.error?.data.map((t) => t.message).join("; "));
        return
      }
      if (response.error) {
        this.$toast.error(response.error?.data?.message);
        return
      }

      this.$toast.success("Звонок отправлен");
      this.stage = 1;
      this.isRegistration = true;

      return response
    },
    _usersLogin: async function () {
      const body = {
        "username": parseInt(this.form.phone.replace(/[^\d]/g, '')),
        "password": this.form.code
      };
      if (this.isRecaptcha) {
        body['g-recaptcha-response'] = await this._getRecaptcha();
      }
      const response = await this.$api.agent.transport.post("/users/login", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: err.response}
      });
      if (response.error?.status === 500 || !response) {
        this.$toast.error("Ошибка сервера, повторите попытку позднее.");
        return
      }
      if (response.error?.data?.[0]?.message) {
        this.$toast.error(response.error?.data.map((t) => t.message).join("; "));
        return
      }
      if (response.error) {
        this.$toast.error(response.error?.data?.message);
        return
      }

      await this.successAuthRegistration(response);
    },
    _usersConfirmPhone: async function () {
      const body = {
        "phone": parseInt(this.form.phone.replace(/[^\d]/g, '')),
        "token": this.form.code
      }
      if (this.isRecaptcha) {
        body['g-recaptcha-response'] = await this._getRecaptcha();
      }
      const response = await this.$api.agent.transport.post("/users/confirm/phone", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: err.response}
      });
      if (response.error?.status === 500 || !response) {
        this.$toast.error("Ошибка сервера, повторите попытку позднее.");
        return
      }
      if (response.error?.data?.[0]?.message) {
        this.$toast.error(response.error?.data.map((t) => t.message).join("; "));
        return
      }
      if (response.error) {
        this.$toast.error(response.error?.data?.message);
        return
      }

      await this.successAuthRegistration(response);
    },

    _getRecaptcha: async function () {
      const code = await this.$recaptcha.getResponse().then((res) => {
        return res
      }).catch(() => {
        return ""
      });
      await this.$recaptcha.reset();
      return code
    },

    successAuthRegistration: async function (response) {
      const token = response?.token;

      // Установка токена в куки
      this.$store.dispatch("userAuth/setToken", {
        authToken: token
      });
      const cookiesOpt = this.$getCookiesOpt({
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5))
      })
      this.$cookies.set('authToken', token, cookiesOpt);
      await this.$store.dispatch("mindbox/usersAuth");

      // Получение пользователя
      await this.$store.dispatch("user/getUser", {
        expanded: true
      });

      this.closeForm();
      if (this.options?.skipUpdate) {
        return null
      }
      if (this.$route.path === "/profile" || this.options?.reloadPage) {
        this.$router.go(this.$router.currentRoute);

        return null
      }
      window.location.href = '/profile';
    },
    resetForm: function () {
      this.form = {
        phone: "",
        code: ""
      };
      this.isRegistration = false;
      this.$v.$reset();

      setTimeout(() => {
        this.stage = 0;
      }, 1000);
    },
    closeForm: function () {
      this.resetForm();
      this.$emit('close');
    },


    authorizationMyAcuvue: function() {
      this.closeForm();
      this.$emit('openDialogAuthorizationMyAcuvue');
    }
  }
}
